var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Outline Icon",
    viewBox: "0 0 64 80",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3,14.63l-3.49-3.49c-1.33-1.33-3.65-1.33-4.98,0L26.49,29.48c-.13,.13-.22,.29-.26,.46l-2.37,9.43c-.09,.34,.01,.7,.26,.95,.19,.19,.45,.29,.71,.29,.08,0,.16,0,.24-.03l9.43-2.37c.18-.04,.34-.13,.46-.26l18.34-18.34c1.37-1.37,1.37-3.61,0-4.98Zm-1.41,3.57l-1.9,1.9-2.82-2.82c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l2.82,2.82-14.83,14.83-7.54,1.89,1.89-7.54,14.88-14.88c.05,.09,.09,.18,.17,.26l.56,.56c.2,.2,.45,.29,.71,.29s.51-.1,.71-.29c.39-.39,.39-1.02,0-1.41l-.56-.56c-.08-.08-.17-.12-.26-.17l1.94-1.94c.58-.58,1.58-.58,2.15,0l3.49,3.49c.59,.59,.59,1.56,0,2.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.45,31c-.55,0-1,.45-1,1v18.7c0,.66-.54,1.19-1.19,1.19H12.86c-.66,0-1.19-.54-1.19-1.19V20.3c0-.66,.54-1.19,1.19-1.19H32c.55,0,1-.45,1-1s-.45-1-1-1H12.86c-1.76,0-3.19,1.43-3.19,3.19v30.4c0,1.76,1.43,3.19,3.19,3.19h30.4c1.76,0,3.19-1.43,3.19-3.19v-18.7c0-.55-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.58,23.46c0-.55-.45-1-1-1H15.22c-.55,0-1,.45-1,1s.45,1,1,1h11.36c.55,0,1-.45,1-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32,27.42h-7.1c-.55,0-1,.45-1,1s.45,1,1,1h7.1c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22,34.39h7.1c.55,0,1-.45,1-1s-.45-1-1-1h-7.1c-.55,0-1,.45-1,1s.45,1,1,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22,39.35h5.34c.55,0,1-.45,1-1s-.45-1-1-1h-5.34c-.55,0-1,.45-1,1s.45,1,1,1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.48,42.32H15.22c-.55,0-1,.45-1,1s.45,1,1,1h22.27c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.22,48.28c0,.55,.45,1,1,1h24.87c.55,0,1-.45,1-1s-.45-1-1-1H15.22c-.55,0-1,.45-1,1Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 79,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Dony 3W")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 84,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.69c454fcc64c3bd64b5c6be921869ac7.svg";
export { ForwardRef as ReactComponent };